export enum WidgetTitles {
	FAQ = 'Frequently asked questions',
	UsefulLinks = 'Useful links'
}
